export default __webpack_public_path__ + "static/media/OTorpedoClosed.9bf0fbfa.jpg";